import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("TextImageSlide", {
  title: "TextImageSlide",
  attributes: {
    smallHeader: {
      title: "Small header",
    },
    teaserText: {
      title: "Teaser Text",
    },
    backgroundImage: {
      title: "Background image",
      description: "This image will slide in from the right",
    },
    targetLink: {
      title: "URL",
    },
    body: {
      title: "Body",
    },
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [
    "title",
    "smallHeader",
    "teaserText",
    "backgroundImage",
    "displayLinkTitle",
    "targetLink",
    "textHorizontalAlignment",
    "textVerticalAlignment",
    "textAlignemnt",
    "buttonStyle",
    ...defaultPageProperties,
  ],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: ["body", "targetLink"],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  validations: [...metadataValidations],
});
